import React from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { Box } from '@material-ui/core';
import { PublicRouteLayout } from '../../../../layout';
import { Typography } from '../../../../ui-kit';

const ErrorBoundary: React.FC = ({ children }) => {
    return (
        <SentryErrorBoundary
            fallback={({ error, componentStack }) => (
                <PublicRouteLayout>
                    <Box m='auto'>
                        <Typography>You have encountered an error</Typography>
                        <Typography>{error.toString()}</Typography>
                        <details>
                            <Box my={2}>{componentStack}</Box>
                        </details>
                    </Box>
                </PublicRouteLayout>
        )}
        >
            {children}
        </SentryErrorBoundary>
    );
};

export default ErrorBoundary;